<template>
  <div id="app">
    <div id="nav">
      <b-button v-if="updateExists" style="position:absolute;top:0;left:0;z-index:10000000;" @click="refreshApp">
        A new app version is available! Click here to update.
      </b-button>
      <router-link to="/">Home</router-link> |
      <b-dropdown variant="primary" size="sm"  text="Where to?">
        <template v-for="(row, index) in navOptions" >
          <b-dropdown-item :key="index" v-bind:to="row.url" >{{ row.text }}</b-dropdown-item>
        </template>
      </b-dropdown>
      <!-- <router-link to="/about">About</router-link> |
      <router-link to="/ticketlist">Ticketlist</router-link> |
      <router-link to="/tickets">Tickets</router-link> |
      <router-link to="/ordercalendar">Order Calendar</router-link> |
      <router-link to="/faq">FAQ</router-link> |
      <router-link to="/announcement">Announcement</router-link> |
      <router-link to="/charts">Charts</router-link> |
      <router-link to="/rating">Rating</router-link> |
      <router-link to="/booking/calendar">Booking Calendar</router-link> |
      <router-link to="/ordermonthlycalendar">Order Monthly Calendar</router-link> |
      <router-link to="/Hexagon">Hexagon</router-link> |
      <router-link to="/catering">Catering</router-link> -->
    </div>
    
    <router-view />
  </div>
</template>
<script>

  export default {
    name      : 'app',
    bodyClass : 'app',
    components: {},
    data() {
      return {
        refreshing  : false,
        registration: null,
        updateExists: false,
        title       : "Main App",
        navOptions: [
         {url: "/ticketlist",           text: "Ticketlist"},
         {url: "/tickets",              text: "Tickets"},
         {url: "/ordercalendar",        text: "Order Calendar"},
         {url: "/faq",                  text: "FAQ"},
         {url: "/announcement",         text: "Announcement"},
         {url: "/charts",               text: "Charts"},
         {url: "/jsonedit",             text: "JSON Edit Test"},
         {url: "/rating",               text: "Rating"},
         {url: "/booking/calendar",     text: "Booking Calendar"},
         {url: "/ordermonthlycalendar", text: "Order Monthly Calendar"},
         {url: "/Hexagon",              text: "Hexagon"},
         {url: "/catering",             text: "Catering"},
         {url: "/filterTest",           text: "Filter Test"},
         {url: "/barcode-scanner",      text: "BarCodeScanner"},
         {url: "/report",               text: "Report Control"}
        ]
      }
    },
    mounted() {
    },
    created() {
      document.addEventListener(
        'swUpdated', this.showRefreshUI, {once: true}
      );
      navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if(this.refreshing) {
            return;
          }
          this.refreshing = true;
          window.location.reload();
        }
      );
    },
    methods   : {
      refreshApp() {
        console.log("clicked refreshApp()");
        this.updateExists = false;
        if(!this.registration || !this.registration.waiting) { return; }
        this.registration.waiting.postMessage('skipWaiting');
      },
      showRefreshUI(e) {
        this.registration = e.detail;
        this.updateExists = true;
      },
    }
  }

</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
